module.exports = __webpack_public_path__ + "img/humm-logo-orange.07dc3555.svg";